<template>
  <div v-if="hidePage" v-loading="loading" class="fireContainer">
    <div v-for="(it, idx) in list" :key="idx">
      <el-button v-if="it.overrun == 1" v-show="activeName == 'all' || activeName == 'overlimit'" class="l-btn" style="height: 2.5rem;" type="primary" @click="openFlicker">
        {{ flag ? "关闭闪动" : "开启闪动" }}
      </el-button>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <h3>室外消火栓检测</h3>
      <!-- 全部 -->
      <el-tab-pane label="全部" name="all">
        <div class="list">
          <div v-for="(it, idx) in list" :key="idx" :class="{ selected: selected === idx }" class="content cursor" @click="choose(it.deviceNo, idx)">
            <el-card shadow="hover">
              <div :class="[it.overrun == 1 ? (flag ? 'firewaring' : '') : it.overrun == 2 ? 'offline_img' : 'fire_img1']">
                <div class="top">
                  <div class="fire">
                    <div :class="it.tilt == 1 ? ' fire_img1' : it.tilt == 1 ? 'fire_img' : it.overrun == 1 ? 'overrun_img' : 'overrun_img'"></div>
                    <img v-if="it.electric == 1" class="fire_power" src="@/assets/img/power_blue.png"/>
                    <img v-else class="fire_power-red" src="@/assets/img/power_red.png"/>
                  </div>
                </div>
                <el-divider></el-divider>
                <div class="down">
                  <span> 水压检测：</span>
                  <span class="down_font2">{{ it.hydraulic == null ? "暂无数据" : it.hydraulic }}</span>
                  <span> 倾斜情况：</span>
                  <span class="down_font2">{{ it.tilt == null ? "暂无数据" : it.tilt == 1 ? "正常" : "倾斜" }}</span>
                  <span>电量情况：</span>
                  <span class="down_font2">{{ it.electric == null ? "暂无数据" : it.electric == 1 ? "正常" : "低电" }}</span>
                  <span> 设备位置：</span>
                  <span class="down_font2">
										<el-input v-show="it.show" ref="position" v-model="it.position" @blur="sure(it, idx)"></el-input>
										<font v-show="!it.show" :key="key" :title="it.position">
											{{ it.position == null ? "暂无数据" : it.position || "暂无数据" }}
										</font>
										<i class="el-icon-edit-outline fonts" @click="edit(it, idx)"></i>
									</span>
                </div>
              </div>
            </el-card>
          </div>
        </div>
      </el-tab-pane>

      <!-- 正常 -->
      <el-tab-pane label="正常" name="normal">
        <div v-if="overrun == 0">
          <div class="list">
            <div v-for="(it, idx) in list" :key="idx" :class="{ selected: selected === idx }" class="content cursor" @click="choose(it.deviceNo, idx)">
              <el-card shadow="hover">
                <div class="top">
                  <div class="fire">
                    <div :class="it.tilt == 1 ? ' fire_img1' : 'fire_img'"></div>
                    <img v-if="it.electric == 1" class="fire_power" src="@/assets/img/power_blue.png"/>
                    <img v-else class="fire_power-red" src="@/assets/img/power_red.png"/>
                  </div>
                </div>
                <el-divider></el-divider>
                <div class="down">
                  <span> 水压检测：</span>
                  <span class="down_font2">{{ it.hydraulic == null ? "暂无数据" : it.hydraulic }}</span>
                  <span> 倾斜情况：</span>
                  <span class="down_font2">{{ it.tilt == null ? "暂无数据" : it.tilt == 1 ? "正常" : "倾斜" }}</span>
                  <span>电量情况：</span>
                  <span class="down_font2">{{ it.electric == null ? "暂无数据" : it.electric == 1 ? "正常" : "低电" }}</span>
                  <span> 设备位置：</span>
                  <span class="down_font2">
										<el-input v-show="it.show" ref="position" v-model="it.position" @blur="sure(it, idx)"></el-input>
										<font v-show="!it.show" :key="key" :title="it.position">
											{{ it.position == null ? "暂无数据" : it.position || "暂无数据" }}
										</font>
										<i class="el-icon-edit-outline fonts" @click="edit(it, idx)"></i>
									</span>
                </div>
              </el-card>
            </div>
          </div>
        </div>
        <Empty v-else :height="325" :message="'暂无数据'"></Empty>
      </el-tab-pane>

      <!-- 超限 -->
      <el-tab-pane label="超限" name="overlimit">
        <div v-if="overrun == 1">
          <div class="list ">
            <div v-for="(it, idx) in list" :key="idx" :class="{ selected: selected === idx }" class="content  cursor" @click="choose(it.deviceNo, idx)">
              <el-card shadow="hover">
                <div :class="flag ? 'firewaring' : ''">
                  <div class="top ">
                    <div class="fire">
                      <div class="overrun_img"></div>
                      <img v-if="it.electric == 1" class="fire_power" src="@/assets/img/power_blue.png"/>
                      <img v-else class="fire_power-red" src="@/assets/img/power_red.png"/>
                    </div>
                  </div>
                  <el-divider style="opacity: .5;"></el-divider>
                  <div class="down">
                    <span> 水压检测：</span>
                    <span class="down_font2">{{ it.hydraulic == null ? "暂无数据" : it.hydraulic }}</span>
                    <span> 倾斜情况：</span>
                    <span class="down_font2">{{ it.tilt == null ? "暂无数据" : it.tilt == 1 ? "正常" : "倾斜" }}</span>
                    <span>电量情况：</span>
                    <span class="down_font2">{{ it.electric == null ? "暂无数据" : it.electric == 1 ? "正常" : "低电" }}</span>
                    <span> 设备位置：</span>
                    <span class="down_font2">
											<el-input v-show="it.show" ref="position" v-model="it.position" @blur="sure(it, idx)"></el-input>
											<font v-show="!it.show" :key="key" :title="it.position">
												{{ it.position == null ? "暂无数据" : it.position || "暂无数据" }}
											</font>
											<i class="el-icon-edit-outline fonts" @click="edit(it, idx)"></i>
										</span>
                  </div>
                </div>
              </el-card>
            </div>
          </div>
        </div>
        <Empty v-else :height="325" :message="'暂无数据'"></Empty>
      </el-tab-pane>

      <!-- 离线 -->
      <el-tab-pane label="离线" name="offline">
        <div v-if="overrun == 2">
          <div class="list">
            <div v-for="(it, idx) in list" :key="idx" :class="{ selected: selected === idx }" class="content cursor" @click="choose(it.deviceNo, idx)">
              <el-card shadow="hover">
                <div class="top">
                  <div class="fire">
                    <div class="offline_img"></div>
                    <img v-if="it.electric == 1" class="fire_power" src="@/assets/img/power_blue.png"/>
                    <img v-else class="fire_power-red" src="@/assets/img/power_red.png"/>
                  </div>
                </div>
                <el-divider></el-divider>
                <div class="down">
                  <span> 水压检测：</span>
                  <span class="down_font2">{{ it.hydraulic == null ? "暂无数据" : it.hydraulic }}</span>
                  <span> 倾斜情况：</span>
                  <span class="down_font2">{{ it.tilt == null ? "暂无数据" : it.tilt == 1 ? "正常" : "倾斜" }}</span>
                  <span>电量情况：</span>
                  <span class="down_font2">{{ it.electric == null ? "暂无数据" : it.electric == 1 ? "正常" : "低电" }}</span>
                  <span> 设备位置：</span>
                  <span class="down_font2">
										<el-input v-show="it.show" ref="position" v-model="it.position" @blur="sure(it, idx)"></el-input>
										<font v-show="!it.show" :key="key" :title="it.position">
											{{ it.position == null ? "暂无数据" : it.position || "暂无数据" }}
										</font>
										<i class="el-icon-edit-outline fonts" @click="edit(it, idx)"></i>
									</span>
                </div>
              </el-card>
            </div>
          </div>
        </div>
        <Empty v-else :height="325" :message="'暂无数据'"></Empty>
      </el-tab-pane>
    </el-tabs>

    <div v-if="activeName == 'all'" class="content2">
      <fireHydrant :fireDataList="fireDataList"></fireHydrant>
    </div>
  </div>
</template>
<script>
import config from "../../utils/config.js";
import {fireHydrantData,outdoorlist} from "../../api/facility.js";
import {mapState} from "vuex";
import fireHydrant from "./components/fireHydrant.vue";

export default {
  props: ["cpNum", "nowDevice"],
  components: {fireHydrant},
  data() {
    return {
      list: [], // 数据列表
      listarea: {
        type: "",
        wsType: 1,
      },
      hidePage: false, // 隐藏页面
      websock: null, // 实时推送
      show: false,
      loading: true,
      fireDataList: [],
      fireNo: "",
      key: "",
      activeName: "all",
      selected: 0,
      overrun: "", // 超限
      flag: true, // 闪动状态
    };
  },

  computed: {
    ...mapState(["otherBjList"]),
  },
  watch: {
    // 单位名称 请求接口
    cpNum() {
      this.activeName = "all";
      this.getList();
    },
  },

  mounted() {
    // if (this.$local.get("company").c_company_num) this.cpNum = this.$local.get("company").c_company_num;
    if (this.cpNum) this.getList();
  },
  created() {
    this.initWebSocket();
  },
  destroyed() {
    //离开路由之后断开websocket连接
  },
  methods: {
    openFlicker() {
      this.flag = !this.flag;
    },
    choose(it, idx) {
      this.selected = idx;
      this.fireNo = it;

      this.getFireList();
    },
    getList() {
      var cNum = this.cpNum == "ee7a45afdd0540d59efc25eb7f3bde74" ? "93fe79c642aa44e182aa3c793dfc9b55" : this.cpNum;
      outdoorlist({companyNum: cNum}).then((res) => {
        if (res.data.length) {
          this.list = res.data;
          this.hidePage = true;
          this.loading = false;
          this.fireNo = res.data[0].deviceNo;
          this.getFireList();

          this.list.map((it, idx) => {
            it.idx = idx;
            it.focus = false;
            it[idx].show = false;
          });
        }
        this.key = this.list.map((it, idx) => {
          it.idx = idx;
        });
        if (!res.data.length) {
          this.fireDataList = [];
          this.hidePage = false;
          this.$message.warning("该业务尚未开通，请联系管理员");
        }
      });
      return;
    },
    edit(it, idx) {
      this.list?.forEach((item, i) => {
        item.show = i === idx;
      });
      this.$nextTick(() => {
        this.$refs.position[idx].focus();
      });
      this.list[idx].show = true;
      return;
    },
    sure(it, idx) {
      var obj = {
        idx: idx,
        type: it.type,
        id: it.id,
        position: it.position,
        deviceNo: it.deviceNo,
      };
      this.$put(`/device/monitorDevice/editPosition`, obj).then((res) => {
        this.list[idx].show = false;
        if (res.code == 200) {
          this.editPosition = res.data;
          return this.$message({message: res.msg,type: "success", duration: 700,});
        }
      });
      this.getList();
      return;
    },
    initWebSocket() {
      //初始化weosocket
      // const wsuri = "ws://47.105.170.47:8888/ws/mqt";
      let wsUrl = "";
      if (process.env.NODE_ENV == "development") {
        //本地
        wsUrl = config.wsUrltest;
      } else if (process.env.NODE_ENV == "production") {
        //线上
        wsUrl = config.wsUrl;
      }
      this.websock = new WebSocket(wsUrl);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    websocketonopen() {
      log("链接");
      //连接建立之后执行send方法发送数据
      let message = "fasong";
      this.websocketsend(JSON.stringify(message));
    },
    websocketonerror() {
      //连接建立失败重连
      this.initWebSocket();
    },
    websocketonmessage(e) {
      // log(e, 'get tui');
      //数据接收
      const redata = JSON.parse(e.data);
      for (const iterator of redata) {
        if (iterator.type == "272" && iterator.wsType == 1)
          for (const it of this.list) {
            if (it.deviceNo == iterator.deviceNo) {
              it = Object.assign(it, iterator);
              this.getList();
            }
          }
      }
    },
    websocketsend(Data) {
      //数据发送
      this.websock.send(Data);
    },
    getFireList() {
      var cNum = this.cpNum == "ee7a45afdd0540d59efc25eb7f3bde74" ? "93fe79c642aa44e182aa3c793dfc9b55" : this.cpNum;
      var obj = {
        address: this.fireNo,
        companyNum: cNum,
      };
      fireHydrantData({companyNum: cNum, ...Object.assign(obj)}).then((res) => {
        if (res.data) {
          // log(res, 111);
          this.fireDataList = res.data;
        }
      });
    },
    handleClick(tab, event) {
      this.getList();
      // log(tab.idx.toString(), event);
      var _idx = tab.idx.toString();
      if (_idx !== 0) {
        this.selected = 0;
        if (_idx == 0 || _idx == 1) {
        }
        if (_idx == 2 || _idx == 3) {
          var cNum = this.cpNum == "ee7a45afdd0540d59efc25eb7f3bde74" ? "93fe79c642aa44e182aa3c793dfc9b55" : this.cpNum;
          outdoorlist({companyNum: cNum}).then((res) => {
            if (res.data.length) {
              this.list = res.data;
              this.hidePage = true;
              this.loading = false;
              this.fireNo = res.data[0].deviceNo;

              this.list.map((it, idx) => {
                it.idx = idx;
                it.focus = false;
              });
            }
            this.key = this.list.map((it, idx) => {
              it.idx = idx;
            });
          });
          return;
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
body {
  scroll-behavior: smooth;
}

.fire {
  background: transparent !important;
}

.selected {
  width: 100%;
  height: 100%;
  border: 2px solid blueviolet;
  // box-shadow: 0px 0px 10px blueviolet;
}

.list {
  display: gap;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: start;
  display: flex;

  .border {
    // border: 1px solid #000;
    box-shadow: 1px 1px 1px 5px #ccc;
  }

  .content {
    width: 18%;
    min-width: 250px;
    max-width: 300px;
    margin: 5px;

    .top {
      flex: 2;
      display: flex;
      justify-content: space-around;
      align-its: center;
      position: relative;

      // 消火栓
      .fire_img {
        width: 100px;
        height: 160px;
        // transform: rotateZ(10deg);
        background: url("~@/assets/img/fire_img.png") no-repeat center;
        background-size: 90% 90%;
        // rotate 3s ease-in-out infinite both
        // animation: fire 3s linear  ease-in-out;
        // animation: fire 4s infinite 0.1s ease;
        // cubic-bezier(.12,.81,.15,.88)
        animation: fire 3s infinite alternate cubic-bezier(0.12, 0.99, 0.1, 0.99);
      }

      .overrun_img {
        width: 100px;
        height: 160px;
        background: url("~@/assets/img/fire_img.png") no-repeat center;
        background-size: 90% 90%;
        // animation: overrun 0.8s infinite alternate cubic-bezier(0, -0.01, 0.23, 0.78);
      }

      .offline_img {
        width: 100px;
        height: 160px;
        background: url("~@/assets/img/fire_img.png") no-repeat center;
        background-size: 90% 90%;
        opacity: 0.5;
      }

      .fire_img1 {
        width: 100px;
        height: 160px;
        background: url("~@/assets/img/fire_img.png") no-repeat center;
        background-size: 90% 90%;
      }
    }

    // infinite
    @keyframes fire {
      0% {
        transform: rotateZ(0deg);
      }

      100% {
        transform: rotateZ(10deg);
      }
    }
    @keyframes overrun {
      0% {
        opacity: 0;
      }
      50% {
        // opacity: 0.5;
      }
      100% {
        opacity: 1;
      }
    }

    .fire_power {
      width: 40px;
      height: 30px;
      position: absolute;
      top: 0;
      right: 10px;
    }

    .fire_power-red {
      width: 40px;
      height: 30px;
      position: absolute;
      top: 0;
      right: 10px;
      animation: power 0.5s infinite 1s alternate;
    }

    @keyframes power {
      0% {
        opacity: 0.5;
      }
      100% {
        opacity: 1;
      }
    }
  }

  .down {
    flex: 1;
    display: grid;
    /* 指定每一行的宽度 每个宽度中间用空格隔开 */
    grid-template-rows: 2.5rem 2.5rem 2.5rem 2.5rem;
    /* 指定每一列的宽度 每个宽度中间用空格隔开 */
    grid-template-columns: 50% 50%;
    text-align: center;
    line-height: 3;
    position: relative;

    .fonts {
      position: absolute;
      bottom: 8px;
      left: 12px;
      cursor: pointer;
      font-size: 1.25rem;
    }
  }
}

.firewaring {
  z-idx: 9999;
  border-radius: 0 !important;
  animation: warningmove 0.3s infinite;
  animation-direction: alternate;
  // animation: warningmove 0.3s infinite;
}

@keyframes warningmove {
  from {
    background: #ed1c24;
  }
  to {
    background: #ffb800;
  }
}

// heartBeat
::v-deep .el-input__inner {
  height: 30px;
  width: 7.5rem;
}

.fireContainer {
  // overflow: auto;
  width: 100%;
  height: 80vh;
  position: relative;

  .l-btn {
    position: absolute;
    right: 0;
    z-idx: 99;
    top: 4px;
  }
}

.down_font2 {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

::v-deep .el-tabs__nav-wrap::after {
  width: 260px;
}

.el-divider--horizontal {
  margin: 0 !important;
  opacity: 0.3 !important;
}

::v-deep .el-card__body {
  padding: 0;
}
</style>
